<div style="background-color: #fff; padding: 0 20px 0 20px;font-family: Arial" class="pdfViewer">
    <!-- <div style="position: absolute; top: 33px;" [ngStyle]="{width: (w -30- 6) + 'px'}">
        <div style="border-top: 1px solid black;height:70px; margin: 20px 80px;padding-top: 10px;">
            <div style="width:40%; text-align: left;display:inline-block; font-size: .9em;vertical-align: top;">
                <span>
                    <b>Project Name:</b> {{reportService.templateModel.description}}
                </span><br>
                <span>
                    <b>Address</b>: {{reportService.templateModel.addr}}
                </span><br>
                <span>
                    <b>Project No:</b> {{reportService.templateModel.pno}}
                </span>
            </div>
            <div
                style="width:40%; text-align: left; vertical-align: top;  display:inline-block; font-weight: bold;font-size: 1.1em;">
                <span>{{reportService.templateModel.caption}}</span>
            </div>
            <div [ngStyle]="{backgroundImage: 'url(' + reportService.templateModel.logo + ')'}"
                style="height: 70px; width:20%; background-position: center; background-repeat: no-repeat; background-size: contain;display:inline-block">
            </div>

        </div>
    </div> -->
    <div *ngFor="let i of pageNo">
        <div style="position: relative;" [ngStyle]="{width: (w - 40) + 'px', height: h + 'px'}">
            <div class="wt5" style="position: absolute; top: 33px;" [ngStyle]="{width: (w - 40 - 2) + 'px'}">
                <div [ngStyle]="{height: (h - 220 -12)/2 + 'px'}">
                    <div style="margin: 30px 80px; ">
                        <div style="margin: 0;  width:100%; overflow:hidden; text-align: center;border:0px solid black  "
                            [ngStyle]="{height: (h - 160 - 80-70)/2 + 'px'}">
                            <img style="border-style: none; margin-left:auto; margin-right:auto; height: 100%; width:100%; display:block;"
                                class="center" [src]="photos[i].FILE_URL" />
                        </div>
                        <div style="margin: 4px; text-align: left;font-weight: bold;font-size: .8em;">
                            <span>Photo {{i+1}}</span>
                            <!--<span *ngIf="selectedPhotos[i].title.length>0"> - {{selectedPhotos[i].title}}</span>-->
                        </div>
                        <p *ngIf="photos[i].FILE_DESCRIPTION" style="margin: 4px; text-align: left;font-size: .8em;">
                            Comments: {{photos[i].FILE_DESCRIPTION}}</p>

                    </div>
                </div>
                <div [ngStyle]="{height: (h - 220 -12)/2 + 'px'}">
                    <div *ngIf="photos.length>(i+1)" style="margin: 30px 80px; ">
                        <div style="margin: 0; width:auto; overflow:hidden; text-align: center; border:0px solid black "
                            [ngStyle]="{height: (h - 160 - 80-70)/2 + 'px'}">
                            <img style="border-style: none; margin-left:auto; margin-right:auto; height: 100%; width:100%; display:block;"
                                class="center" [src]="photos[i+1].FILE_URL" />
                        </div>
                        <div style="margin: 4px; text-align: left;font-weight: bold;font-size: .8em;">
                            <span>Photo {{i+2}}</span>
                            <!--<span *ngIf="selectedPhotos[i+1].title.length>0"> - {{selectedPhotos[i+1].title}}</span>-->
                        </div>
                        <p *ngIf="photos[i+1].FILE_DESCRIPTION" style="margin: 4px; text-align: left;font-size: .8em;">
                            Comments: {{photos[i+1].FILE_DESCRIPTION}}</p>

                    </div>
                </div>
                <div style="border-top: 1px solid black;height:70px; margin: 20px 80px;padding-top: 10px;">
                    <div style="width:40%; text-align: left;display:inline-block; font-size: .9em;vertical-align: top;">
                        <span>
                            <b>Project Name:</b> {{reportService.templateModel.description}}
                        </span><br>
                        <span>
                            <b>Address</b>: {{reportService.templateModel.addr}}
                        </span><br>
                        <span>
                            <b>Project No:</b> {{reportService.templateModel.pno}}
                        </span>
                    </div>
                    <div
                        style="width:40%; text-align: left; vertical-align: top;  display:inline-block; font-weight: bold;font-size: 1.1em;">
                        <span>{{reportService.templateModel.caption}}</span>
                    </div>
                    <div [ngStyle]="{backgroundImage: 'url(' + reportService.templateModel.logo + ')'}"
                        style="height: 70px; width:20%; background-position: center; background-repeat: no-repeat; background-size: contain;display:inline-block">
                    </div>

                </div>
            </div>
        </div>
        <p *ngIf="i<pageNo[pageNo.length-1]" style="page-break-after: always;">
    </div>
</div>